import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-right-circle",
  "use": "icon-a-right-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-right-circle\" id=\"icon-a-right-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><polyline points=\"12 16 16 12 12 8\" /><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol